export const toogleUserBar = () =>{
    return dispatch => {
        dispatch({type: 'TOOGLE_USER_BAR'})
    }
}